import React, { Component } from 'react';

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();

    return (
      <span className="footer">
        By using Medsender, you agree to the&nbsp;
        <a href="https://medsender.com/privacy-policy">Privacy Policy</a>
        {' '}
        and&nbsp;
        <a href="https://medsender.com/terms-of-service">Terms of Use</a>
        <br />
        &copy;
        {' '}
        {currentYear}
        {' '}
        Medsender, Inc.
      </span>
    );
  }
}

export default Footer;
